<template>
  <div class="audit-auth-owner-undo-container">
    <!-- 认证申请人信息 -->
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('auditAuthOwnerUndo.title') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="goBack">
          {{ $t('auditAuthOwnerUndo.back') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">认证人姓名</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.appUserName }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">手机号</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.link }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">身份证号</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.idCard }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">身份角色</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.ownerTypeCdName || '-' }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">绑定业主</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.ownerName || '-' }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 房屋信息（房屋认证模式） -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.roomId">
      <div slot="header" class="flex justify-between">
        <span>房屋信息</span>
      </div>
      <el-row :gutter="20" v-if="auditAuthOwnerUndoInfo.room && auditAuthOwnerUndoInfo.room.roomName">
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">{{ $t('auditAuthOwnerUndo.roomNumber') }}</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.room.roomName }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">{{ $t('auditAuthOwnerUndo.roomArea') }}</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.room.builtUpArea }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">{{ $t('auditAuthOwnerUndo.roomType') }}</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.room.roomSubTypeName }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">{{ $t('auditAuthOwnerUndo.roomStatus') }}</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.room.stateName }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">{{ $t('auditAuthOwnerUndo.owner') }}</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.room.ownerName }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">{{ $t('auditAuthOwnerUndo.ownerPhone') }}</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.room.link }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 车位认证信息 -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.psId || auditAuthOwnerUndoInfo.carNum || auditAuthOwnerUndoInfo.psName">
      <div slot="header" class="flex justify-between">
        <span>车位认证信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="8" v-if="auditAuthOwnerUndoInfo.carNum">
          <div class="form-item">
            <label class="form-label">车牌号</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.carNum }}</div>
          </div>
        </el-col>
        <el-col :span="8" v-if="auditAuthOwnerUndoInfo.psName">
          <div class="form-item">
            <label class="form-label">车位</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.psName }}</div>
          </div>
        </el-col>
        <el-col :span="8" v-if="auditAuthOwnerUndoInfo.psId">
          <div class="form-item">
            <label class="form-label">车位ID</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.psId }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 房屋已有成员（房屋认证模式） -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.roomId">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('auditAuthOwnerUndo.housePersonnel') }}</span>
      </div>
      <el-table :data="auditAuthOwnerUndoInfo.owners" border style="width: 100%">
        <el-table-column prop="url" :label="$t('auditAuthOwnerUndo.ownerFace')" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 60px; height: 60px;"
              :src="scope.row.url || '/img/noPhoto.jpg'"
              :preview-src-list="[scope.row.url]"
              fit="cover"
              class="border-radius"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('auditAuthOwnerUndo.name')" align="center"></el-table-column>
        <el-table-column prop="link" :label="$t('auditAuthOwnerUndo.contact')" align="center"></el-table-column>
        <el-table-column prop="idCard" :label="$t('auditAuthOwnerUndo.idCard')" align="center">
          <template slot-scope="scope">
            {{ scope.row.idCard || '-' }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 证明图片 -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.photoUrls.length > 0">
      <div slot="header" class="flex justify-between">
        <span>认证证明材料</span>
      </div>
      <div class="photo-list">
        <el-image
          v-for="(url, index) in auditAuthOwnerUndoInfo.photoUrls"
          :key="index"
          style="width: 120px; height: 120px; margin-right: 12px; border-radius: 8px;"
          :src="url"
          :preview-src-list="auditAuthOwnerUndoInfo.photoUrls"
          fit="cover"
        ></el-image>
      </div>
    </el-card>

    <!-- 审核操作（仅待审核状态显示） -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.state === '10000'">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('auditAuthOwnerUndo.audit') }}</span>
      </div>
      <el-form label-width="120px">
        <el-form-item :label="$t('auditAuthOwnerUndo.action')">
          <el-select v-model="auditAuthOwnerUndoInfo.audit.state" style="width: 100%">
            <el-option disabled :value="''" :label="$t('auditAuthOwnerUndo.selectAudit')"></el-option>
            <el-option value="1100" :label="$t('auditAuthOwnerUndo.agree')"></el-option>
            <el-option value="1200" :label="$t('auditAuthOwnerUndo.reject')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('auditAuthOwnerUndo.auditRemark')">
          <el-input
            type="textarea"
            :placeholder="$t('auditAuthOwnerUndo.requiredRemark')"
            v-model="auditAuthOwnerUndoInfo.audit.remark"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="auditSubmit">{{ $t('auditAuthOwnerUndo.submit') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 已审核状态显示 -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.state && auditAuthOwnerUndoInfo.state !== '10000'">
      <div slot="header">
        <span>审核结果</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">审核状态</label>
            <div class="form-content">
              <el-tag :type="auditAuthOwnerUndoInfo.state === '12000' ? 'success' : 'danger'">
                {{ auditAuthOwnerUndoInfo.state === '12000' ? '审核通过' : '审核拒绝' }}
              </el-tag>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="form-item">
            <label class="form-label">审核备注</label>
            <div class="form-content">{{ auditAuthOwnerUndoInfo.audit.remark || '-' }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { getRoomInfo, getOwnerList, auditAuthOwner } from '@/api/owner/auditAuthOwnerUndoApi'

// 获取图片展示的基础URL
function getFileBaseUrl() {
  return window.location.origin + '/callComponent/download/getFile/file'
}

export default {
  name: 'AuditAuthOwnerUndoList',
  data() {
    return {
      auditAuthOwnerUndoInfo: {
        room: {},
        roomId: '',
        owners: [],
        appUserName: '',
        link: '',
        idCard: '',
        carNum: '',
        psId: '',
        psName: '',
        ownerName: '',
        ownerTypeCdName: '',
        photoUrls: [],
        state: '',
        audit: {
          state: '',
          remark: '',
          appUserId: ''
        }
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.auditAuthOwnerUndoInfo.audit.appUserId = this.$route.query.appUserId
      this.auditAuthOwnerUndoInfo.roomId = this.$route.query.roomId || ''
      this.auditAuthOwnerUndoInfo.appUserName = this.$route.query.appUserName || ''
      this.auditAuthOwnerUndoInfo.link = this.$route.query.link || ''
      this.auditAuthOwnerUndoInfo.idCard = this.$route.query.idCard || ''
      this.auditAuthOwnerUndoInfo.ownerTypeCdName = this.$route.query.ownerTypeCdName || ''
      this.auditAuthOwnerUndoInfo.ownerName = this.$route.query.ownerName || ''
      this.auditAuthOwnerUndoInfo.state = this.$route.query.state || ''

      // 解析 remark：统一提取车牌号、图片URL、审核意见
      const remark = this.$route.query.remark || ''
      this.parseRemark(remark)

      // 有房屋ID时才加载房屋和业主信息
      if (this.auditAuthOwnerUndoInfo.roomId) {
        this.loadRoom()
        this.loadOwners()
      }
    },

    // 解析 remark 字段：格式为 "车位ID：xxx；车位描述：xxx；车牌号：京A12345；证明图片：fileId1,fileId2；审核意见：通过"
    parseRemark(remark) {
      if (!remark) return
      const parts = remark.split('；')
      const baseUrl = getFileBaseUrl()
      const communityId = getCommunityId()
      const self = this
      parts.forEach(function(part) {
        if (part.startsWith('车位ID：')) {
          self.auditAuthOwnerUndoInfo.psId = part.replace('车位ID：', '')
        } else if (part.startsWith('车位描述：')) {
          self.auditAuthOwnerUndoInfo.psName = part.replace('车位描述：', '')
        } else if (part.startsWith('车牌号：')) {
          self.auditAuthOwnerUndoInfo.carNum = part.replace('车牌号：', '')
        } else if (part.startsWith('证明图片：')) {
          const fileIds = part.replace('证明图片：', '').split(',').filter(function(id) { return id })
          self.auditAuthOwnerUndoInfo.photoUrls = fileIds.map(function(fileId) {
            return baseUrl + '?fileId=' + fileId + '&communityId=' + communityId + '&time=' + Date.now()
          })
        } else if (part.startsWith('审核意见：')) {
          // 审核意见存到 audit.remark 供审核结果卡片显示
          self.auditAuthOwnerUndoInfo.audit.remark = part.replace('审核意见：', '')
        }
      })
    },

    async loadRoom() {
      try {
        const params = {
          page: 1,
          row: 1,
          roomId: this.auditAuthOwnerUndoInfo.roomId,
          communityId: getCommunityId()
        }
        const res = await getRoomInfo(params)
        if (res.rooms && res.rooms.length > 0) {
          this.auditAuthOwnerUndoInfo.room = res.rooms[0]
        }
      } catch (error) {
        console.error('Failed to load room info:', error)
      }
    },
    async loadOwners() {
      try {
        const params = {
          page: 1,
          row: 100,
          roomId: this.auditAuthOwnerUndoInfo.roomId,
          communityId: getCommunityId()
        }
        const res = await getOwnerList(params)
        this.auditAuthOwnerUndoInfo.owners = res.data || []
      } catch (error) {
        console.error('Failed to load owners:', error)
      }
    },
    async auditSubmit() {
      try {
        if (!this.auditAuthOwnerUndoInfo.audit.state) {
          this.$message.warning('请选择审核结果')
          return
        }
        if (!this.auditAuthOwnerUndoInfo.audit.remark) {
          this.$message.warning('请填写审核说明')
          return
        }
        const auditInfo = {
          ...this.auditAuthOwnerUndoInfo.audit,
          communityId: getCommunityId()
        }
        const res = await auditAuthOwner(auditInfo)
        if (res.code !== 0) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.go(-1)
      } catch (error) {
        this.$message.error(this.$t('auditAuthOwnerUndo.submitFailed') + error)
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-auth-owner-undo-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .form-item {
    margin-bottom: 18px;

    .form-label {
      color: #606266;
      margin-right: 10px;
    }

    .form-content {
      display: inline-block;
    }
  }

  .border-radius {
    border-radius: 4px;
  }

  .photo-list {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
